import { render } from "./Images.vue?vue&type=template&id=67b8cdeb&ts=true"
import script from "./Images.vue?vue&type=script&lang=ts"
export * from "./Images.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__